// extracted by mini-css-extract-plugin
module.exports = {"icon-on-left":"nwea-ds-v1-button-icon-on-left","icon-on-right":"nwea-ds-v1-button-icon-on-right","icon-only":"nwea-ds-v1-button-icon-only","outline":"nwea-ds-v1-button-outline"};